import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {EXPIRATION_EXERCISE_ASSIGNMENT_6} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const ExpirationExerciseAssignment6 = "tfExpirationExerciseAssignment6Question";

export function expirationExerciseAssignment6() {
    return {
        templateUrl: "app/quiz/fxe/questions/ExpirationExerciseAssignment6.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: ExpirationExerciseAssignment6Controller
    };
}

export class ExpirationExerciseAssignment6Controller extends FxeQuizQuestionController {
    public config = EXPIRATION_EXERCISE_ASSIGNMENT_6;
}
